<template>
	<div class="small-12" v-if="lease">
		<div class="small-12 sidebarWidget flex vertical-align animated fadeIn" style="padding-top:10px;" v-if="unit"> 
			<div class="small-12 title">
				<h3 class="flex vertical-align">Unit</h3>
			</div>
			<div class="small-12 detailList widget columns borderRadius8 border light" style="background:none;">
				<ul class="float-left small-12 flex">
					<li class="small-12 border-bottom" style="padding-bottom:15px;">
						<p class="flex vertical-align text-overflow small-12">
							<b>Status:</b>
							<span class="badge bgRed borderRadius4" v-if="unit.attributes.available">Available</span>
							<span class="badge bgPrimaryBlue borderRadius4" v-else>Occupied</span>
						</p>
					</li>
					<li class="small-12">
						<p class="flex vertical-align text-overflow small-12 large-6">
							<b>Unit Number:</b>
							{{ unit.attributes.number }}
						</p>
						<p class="flex vertical-align text-overflow small-12 large-6">
							<b>Square Feet:</b>
							{{ unit.attributes.square_feet }}
						</p>
					</li>
					<li class="small-12">
						<p class="flex vertical-align text-overflow small-12 large-6">
							<b>Bedrooms:</b>
							{{ unit.attributes.bedrooms }}
						</p>
						<p class="flex vertical-align text-overflow small-12 large-6">
							<b>Bathrooms:</b>
							{{ unit.attributes.bathrooms }}
						</p>
					</li>
					<li class="small-12">
						<p class="flex vertical-align text-overflow small-12">
							<b>Market Rent:</b>
							${{ unit.attributes.rent.market | convertCentsToDollars }}
						</p>
					</li>
					<li class="small-12 action flex justify-center border-top" style="padding-top:30px;">
						<a class="blueButton flex vertical-align borderRadius4">
							<i class="material-icons flex vertical-align justify-center">home</i>
							View Unit
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div class="small-12 sidebarWidget flex vertical-align animated fadeIn" v-if="lease">
			<div class="small-12 title">
				<h3 class="flex vertical-align">Recent Documents</h3>
			</div>
			<div class="small-12 widget columns borderRadius8 border light" style="background:none;">
				<div class="small-12 leaseDocumentsHeader" v-if="recent_documents && recent_documents.length > 0">
					<p class="small-12">Document Title</p>
				</div>
				<ul class="small-12 flex float-left leaseDocuments" v-if="recent_documents && recent_documents.length > 0">
					<li class="small-12 border-bottom" v-for="(doc, docIndex) in recent_documents" :key="docIndex">
						<uploaded-document :doc="doc"/>
					</li>
					<li class="small-12 action flex justify-center" style="padding-top:30px;">
						<a class="blueButton flex vertical-align borderRadius4">
							<i class="material-icons-outlined flex vertical-align justify-center">file_copy</i>
							View All Documents
						</a>
					</li>
				</ul>
				<div class="small-12 widgetChart emptyWidget small" style="padding-top:15px;" v-else>
					<div class="small-12 wrap flex justify-center">
						<picture class="small-12 flex justify-center" style="width:80%; height:auto;">
							<img width="120" :src="empty_documents_image" alt="Chart in Empty Room">
						</picture>
					</div>
					<div class="small-12 emptyDetails">
						<h6 class="small-12 text-center"> 
							0 Documents Found
						</h6>
						<p class="small-12 text-center"> 
							There are no lease documents available at this time.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { GetPropertyResident } from '@/events/residents/GetPropertyResident'
	import { GetUnit } from '@/events/units/GetUnit'
	import { DatesFilters } from '@/mixins/filters/DatesFilters'
	import { MoneyConversions } from '@/mixins/filters/MoneyConversions'

	// Import the components
	import UploadedDocument from '@/components/property/leases/UploadedDocument.vue'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'LeaseDetails',

		/*
		**  Register the components
		*/

		components: {

			UploadedDocument

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			GetPropertyResident,
			GetUnit,
			DatesFilters,
			MoneyConversions

		],

		/*
		**  Set the props
		*/

		props: {

			lease: {
				type: Object,
				default: () => null
			}

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			empty_documents_image: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/vectors%2Fpage-writing-screen.svg?alt=media&token=eb566a75-e922-4ec0-9c47-0f1e5b4f6522',
			future_item: false,
			recent_documents: null

		}),

		/*
		**  Watch em'
		*/

		watch: {

			lease: {

				immediate: true, // Load on created
				handler(lease) {

					/*
					**  Get the resident
					**  @method: Events/Residents/GetPropertyResident
					*/

					if (lease) this.getPropertyResidentHandler(lease.relationships.resident);

					/*
					**  Get the unit
					**  @method: Events/Units/GetUnit
					*/

					if (lease) this.getUnitHandler(lease.relationships.unit);

					/*
					**  Get the most recent signed documents
					**  @method: @here
					*/

					if (lease) this.getRecentDocuments();

				}

			}

		},

		/*
        ** Do this first
        */

        mounted() {

        	//

        },

        /*
		**  Set up the methods
		*/

		methods: {

			getRecentDocuments: function() {

				/*
				**  Get the most recent signed documents
				**  @prop: @here
				*/

				if (this.lease.links.documents.length > 0) this.recent_documents = this.lease.links.documents.slice(Math.max(this.lease.links.documents.length - 5, 0));

			}

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		},

		/*
		**  Set the filters
		*/

		filters: {

			//

		}

	}

</script>